import { observer } from 'mobx-react';
import { AkumaPrimeListe } from './AkumaPrimeListe';
import { AkumaPrimeSchema, AgtAkumaPrimeKwVM, AkumaPrimeType } from 'app/stores/ui/agt.akumaprime.ui.store';
import { useStore } from 'app/context';
import { useEffect, useState } from 'react';

import { AkumaPrimeHorizontalBarChart } from './AkumaPrimeBarChart';
import _ from 'lodash';
import { AkumaPrimeOptions } from './AkumaPrimeOptions';

interface IAkumaPrimeSchemaAgt {
	primeType: AkumaPrimeType
}
export const AkumaPrimeSchemaList = observer((props: IAkumaPrimeSchemaAgt) => {
	const { berichteUiiStore, agtAkumaPrimeUiStore, agenturListUiStore } = useStore();
	const schema = AkumaPrimeSchema.filter((s) => s.type === props.primeType);

	const [data, setData] = useState<AgtAkumaPrimeKwVM[]>([]);

	useEffect(() => {
		agtAkumaPrimeUiStore.aggreagateAgtsByKw(agtAkumaPrimeUiStore.minKwCurrent, agtAkumaPrimeUiStore.maxKwCurrent).then((res) => {
			const items = agenturListUiStore.applyFilterOnAgt(res) as AgtAkumaPrimeKwVM[];
			setData(items);
		});
	}, [props.primeType, agtAkumaPrimeUiStore, agtAkumaPrimeUiStore.minKwCurrent, agtAkumaPrimeUiStore.maxKwCurrent, berichteUiiStore.selectedAgt, berichteUiiStore.menu, agenturListUiStore.filterHasChanged, agenturListUiStore]);

	return (
		<>
			<div className="table-container pad-bottom-3rem">
				<AkumaPrimeOptions />

				{data.length === 0 ? (
					<>
						<div className="pad-1rem content">
							<h3 className="title is-5">Keine Daten</h3>
							<p>Keine AKUMA Prime teilnahme.</p>
						</div>
					</>
				) : (
					<div className="table-container pad-bottom-3rem">

						<>{agtAkumaPrimeUiStore.showGraphs && <AkumaPrimeHorizontalBarChart data={data} primeType={props.primeType} schema={schema} />}</>

						<AkumaPrimeListe
							schema={schema}
							quoteProps={'einordnungsQuote'}
							totalProps={'einordnungTotal'}
							data={data}
							primeType={AkumaPrimeType.einordnung}
							selectedAgt={berichteUiiStore.selectedAgt}
							showKw={!!berichteUiiStore.selectedAgt}
						/>
					</div>
				)}
			</div>
		</>
	);
});
